import { BULK_LIMIT } from '@/constants';
import { selectedTranslationGroup, selectedTranslations } from '@/pages/translation/state';
import { ITranslation, ITranslationGroup } from '@d-id/types';
import { useRecoilState } from 'recoil';

export const useSelectedTranslationGroups = () => {
    const [selected, setSelected] = useRecoilState(selectedTranslationGroup);

    const onSelect = (item: ITranslationGroup) => setSelected(item);

    const selectMode = !!selected;
    const isSelected = (id: string) => selectMode && selected.id === id;

    return {
        onSelect,
        selectMode,
        isSelected,
        selected,
        reset: () => setSelected(null),
    };
};

export const useSelectedTranslations = () => {
    const [selected, setSelected] = useRecoilState(selectedTranslations);

    const limitReached = selected.size >= BULK_LIMIT;

    const onSelect = (item: ITranslation) => {
        setSelected(currSelected => {
            if (currSelected.has(item.id)) {
                currSelected.delete(item.id);
            } else if (!limitReached) {
                currSelected.set(item.id, item);
            }
            return new Map(currSelected);
        });
    };

    const selectMode = !!selected.size;
    const isSelected = (id: string) => selected.has(id);

    return {
        onSelect,
        selectMode,
        isSelected,
        selected,
        reset: () => setSelected(new Map()),
        limitReached,
    };
};
